import React, { useEffect } from 'react';
import { Button } from '@amzn/stencil-react-components/button';
import { useNavigate } from 'react-router-dom';
import { H1 } from '@amzn/stencil-react-components/text';
import { useTranslation } from 'react-i18next';
import { Flex, Spacer } from '@amzn/stencil-react-components/layout';
import { TabBar, TabSwitcher, TabPanel, useTabs } from '@amzn/stencil-react-components/tabs';
import { FeedbackLoader } from '../shared/FeedbackLoader';
import { CurrentWeekQualityTab } from '../CurrentWeekQualityTab';
import { SQPRSummaryTab } from '../SQPRSummaryTab';
import { metricSender } from '../../util/metric_sender';
import { useGlobalContext, useUserDataContext } from '../../hooks';
import { QualityLookbackReport } from '../QualityLookbackReport';
import { isReportingEnabledForUser } from '../../util/allow_lists';
import { ErrorBoundary } from '../ErrorBoundary';
import {WA_WAREHOUSE_ALLOW_LIST} from "src/constants/featureGates";

export const QualitySummary = ({}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { areMetricsSendable, spprSummaries, sqprSummaries } = useUserDataContext();
  const { userDetails, isAdminViewEnabled } = useGlobalContext();

  useEffect(() => {
    if (areMetricsSendable) {
      metricSender.generateCompetenciesMetrics(
        userDetails,
        spprSummaries,
        sqprSummaries,
        'Quality',
      );
    }
  }, [areMetricsSendable]);

  let tabs = [
    { label: t('thisWeek'), value: 'tab-this-week' },
    { label: t('weeklyQualityReviewSummary'), value: 'tab-sqpr' },
    { label: t('feedbacks'), value: 'tab-feedbacks' },
  ];
  if (isReportingEnabledForUser(userDetails, isAdminViewEnabled)) {
    if (WA_WAREHOUSE_ALLOW_LIST.includes(userDetails.warehouseId)) {
      tabs.push({ label: '26-Week Quality Summary', value: 'tab-quality-report' });
    } else {
      tabs.push({ label: '14-Week Quality Summary', value: 'tab-quality-report' });
    }
  }

  const { tabBarProps, tabSwitcherProps } = useTabs({ tabs });

  return(
    <>
      <Flex flexDirection="row" justifyContent="space-between">
        <H1>{t('ensureQuality')}</H1>
        <Button data-cy="home-btn" onClick={()=>{navigate('/')}}>{t('home')}</Button>
      </Flex>

      <Spacer height={16}/>
      <TabBar {...tabBarProps} />
      <Spacer height={32}/>

      <TabSwitcher {...tabSwitcherProps}>
        <TabPanel value="tab-this-week">
          <ErrorBoundary>
            <CurrentWeekQualityTab />
          </ErrorBoundary>
        </TabPanel>
        <TabPanel value="tab-sqpr">
          <ErrorBoundary>
            <SQPRSummaryTab />
          </ErrorBoundary>
        </TabPanel>
        <TabPanel value="tab-feedbacks">
          <ErrorBoundary>
            <FeedbackLoader feedbackCategories={['Quality']} subtitle={`${t('qualityFeedbacksSubtitle')} ${t('yesterdaysDataTooltip')}`}/>
          </ErrorBoundary>
        </TabPanel>
        <TabPanel value="tab-quality-report">
          <ErrorBoundary>
            <QualityLookbackReport />
          </ErrorBoundary>
        </TabPanel>
      </TabSwitcher>
    </>
  );
}
